import { IConfig } from '@cian/config/shared';
import { ILogger } from '@cian/logger';

interface IExperimentCategories {
  experimentName: string;
  categoriesInfo: ICategoryInfo[];
}

interface ICategoryInfo {
  dealType?: string;
  objectType?: string;
  rentDuration?: string;
  propertyType?: string;
}

type CategoryInfoKey = keyof ICategoryInfo;

export const getExperimentsOnCategoriesList = (config: IConfig, logger: ILogger) => {
  try {
    const BDUIFormExperiments = config.get<IExperimentCategories[]>('BDUIFormExperiments');

    if (!BDUIFormExperiments || !Array.isArray(BDUIFormExperiments)) {
      throw new Error('Не получилось прочитать настройку BDUIFormExperiments в Runtime settings');
    }

    return BDUIFormExperiments;
  } catch (e) {
    logger.error(e);

    return [];
  }
};

export const getExperimentMatchingCategory = (
  experiments: IExperimentCategories[],
  givenCategoryInfo?: ICategoryInfo,
) =>
  experiments.find(({ categoriesInfo }) =>
    categoriesInfo.find(categoryInfo => {
      for (const property in categoryInfo) {
        if (
          !givenCategoryInfo ||
          categoryInfo[property as CategoryInfoKey] !== givenCategoryInfo[property as CategoryInfoKey]
        ) {
          return false;
        }
      }

      return true;
    }),
  );
